'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:CompanioninvitationCtrl
 * @description
 * # CompanioninvitationCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'CompanioninvitationCtrl', [ '$scope', '$rootScope', 'lodash', 'ENV', '$timeout', '$http', 'notificationService', '$sessionStorage', 'messageDictionary', 'RibytUtils', 'Cropper', '$q', '$bootbox', function ctrl ( $scope, $rootScope, _, ENV, $timeout, $http, notificationService, $sessionStorage, $messageDictionary, RibytUtils, Cropper, $q, $bootbox ) {
        var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;

        _.set( $scope, 'requiredField', $messageDictionary.general.required );
        _.set( $rootScope, 'showTabs', true );
        _.set( $scope, 'invite', invite );
        _.set( $scope, 'companions', [] );
        _.set( $rootScope, 'rsvpProcess', 'companionInvitation' );
        _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );

        var byts = _.get( invite, 'byts', [] );
        var airByts = [];
        var hotelByts = [];
        byts.map( function mapTravelByts ( byt ) {
            if ( byt.type === 'Air' ) {
                airByts.push( byt );
            } else if ( byt.type === 'Hotel' ) hotelByts.push( byt );
        } );
        $scope.showAirDeclineOption = false;
        $scope.showHotelDeclineOption = false;
        // Only show if they have qty, it's enabled, and it's accepted
        RibytUtils.defineBytVisibility( airByts, 'showAirDeclineOption', $scope, invite );
        RibytUtils.defineBytVisibility( hotelByts, 'showHotelDeclineOption', $scope, invite );
        $scope.inviteType = 'g';
        _.set( $scope, 'guestInformation', _.get( invite, 'experienceID.guestInformation' ) );

        var paramDefinitions = {
            'personal': {
                'name': false,
                'gender': false,
                'dob': false,
                'profileImage': false,
                'dietaryRestrictions': false,
                'specialNeeds': false,
                'socialMedia': false
            },
            'contact': {
                // Remove email from here since email is not a selectable
                // field under contact fields for RSVP customization, RPT-2036.
                // email: true,
                'phone': {
                    'primary': true,
                    'alternate': true
                },
                'address': true,
                'companyName': true,
                'title': true
            },
            'travel': {
                'homeAirport': false,
                'departureTime': false,
                'returnTime': false,
                'frequentFlyerNo': false,
                'knownTravelerNo': false,
                'seatPreference': false
            }
        };
        var paramRequiredDefinitions = {
            'personal': {
                'gender': true,
                'dob': true,
                'profileImage': false,
                'dietaryRestrictions': false,
                'specialNeeds': false,
                'socialMedia': false
            },
            'contact': {
                'phone': {
                    'primary': true,
                    'alternate': false
                },
                'address': true,
                'companyName': false,
                'title': false
            },
            'travel': {
                'homeAirport': true,
                'departureTime': true,
                'returnTime': true,
                'frequentFlyerNo': false,
                'knownTravelerNo': false,
                'seatPreference': false
            }
        };

        if ( $scope.guestInformation && _.get( invite, 'experienceID.RSVPDetails.isCompanionParamsDisabled' ) ) {
            $scope.guestInformation.companionParams = _.get( invite, 'experienceID.guestInformation.params' );
            $scope.guestInformation.companionParamsRequired = _.get( invite, 'experienceID.guestInformation.paramsRequired' );
        }
        if ( $scope.guestInformation && _.isEmpty( $scope.guestInformation.companionParams ) ) {
            $scope.guestInformation.companionParams = paramDefinitions;
        }
        if ( $scope.guestInformation && _.isEmpty( $scope.guestInformation.companionParamsRequired ) ) {
            $scope.guestInformation.companionParamsRequired = paramRequiredDefinitions;
        }

        var legals = _.filter( _.get( invite, 'experienceID.legals', [] ), function ( legal ) {
            return legal.type['companion'];
        } );

        $scope.canRegisterOnBehalf = legals.length === 0 && invite.experienceID.RSVPDetails.allowRegisterOnBehalf;

        _.set( $scope, 'days', _.range( 1, 32 ) );
        _.set( $scope, 'years', _.reverse( _.range( 1900, moment().year() - 13 ) ) );
        $scope.showTravelInfo = $scope.showAirDeclineOption || $scope.showHotelDeclineOption;
        _.set( $scope, 'showPersonalInfo', true ); // Always show
        _.set( $scope, 'showContactInfo', _.some( RibytUtils.flattenObject( _.get( $scope, 'guestInformation.companionParams.contact' ) ), Boolean ), false );
        _.set( $scope, 'showTravelInfo', _.some( RibytUtils.flattenObject( _.get( $scope, 'guestInformation.companionParams.travel' ) ), Boolean ), false );
        _.set( $scope, 'showAdditionalInfo', _.some( _.get( $scope, 'guestInformation.surveyQuestions' ), { companion: true } ), false );
        $scope.searchAirports = RibytUtils.searchAirports;
        $scope.selectAirport = function selectAirport ( item, index ) {
            $scope.companions[index].travelPreferences.departureAirport = RibytUtils.stringVersionOfAirport( item );
        };

        _.set( $scope, 'saveCompanionInvites', saveCompanionInvites );

        $scope.toggleRegisterOnBehalf = toggleRegisterOnBehalf;
        $scope.toggleEnableCompanion = toggleEnableCompanion;
        $scope.expandCollapseRegisterOnBehalfSection = expandCollapseRegisterOnBehalfSection;

        var numberOfCompanionsAllowed = _.get( invite, 'experienceID.additionalGuests', 0 );
        var guestsAlreadyInvited = _.get( invite, 'companionInfoIDs', [] ).filter( function ( companion ) {
            return !companion.exludedOnRSVP;
        } );
        var guestsNotInvited = _.get( invite, 'guestsNotInvited', 0 );
        var companionsAllowed = numberOfCompanionsAllowed - guestsNotInvited - guestsAlreadyInvited.length;

        $scope.additionalGuests = new Array( companionsAllowed );
        $scope.alreadyInvitedCompanions = _.get( invite, 'companionNames', [] );

        if ( companionsAllowed === 0 ) {
            // they are not allowed to send invites to companions, so set to welcome
            _.set( invite, 'rsvpProcess', 'welcome' );
            _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invite ) );
            $rootScope.redirectProperly( invite );
        }

        if ( $scope.companions.length === 0 ) {
            $scope.companions = Array.apply( null, Array( companionsAllowed ) ).map( function createNewCompanion () {
                return {
                    enabled: true,
                    registerOnBehalfRadio: 'false',
                    registerOnBehalf: false,
                    registerOnBehalfExpanded: false,
                    formattedBirthday: [ '', '', '' ],
                    phone: { sms: { isOptOut: '0' } }
                };
            } );
        }

        function saveCompanionInvites ( $event, form, force ) {
            $event.preventDefault();
            $scope.submitted = true;

            if ( form.$invalid ) {
                notificationService.error( 'Uh-oh, looks like there\'s an error on this form.' );
                return;
            }

            // make sure they fill up all the info
            if ( companionsAllowed !== $scope.companions.length ) {
                notificationService.error( $messageDictionary.error.fillCompanionInfo );
            } else {
                _.set( $scope, 'status', 'Processing...' );

                var commonProperties = {
                    parentID: invite.parentID.id,
                    eventID: invite.eventID.id,
                    experienceID: invite.experienceID.id,
                    invitedByUserID: invite.guestID.id
                };

                var companionEmails = [];
                var atLeastOneCompanion = false;

                _.each( $scope.companions, function prepareCompanions ( companion ) {
                    if ( companion.enabled ) {
                        atLeastOneCompanion = true;
                        _.assign( companion, commonProperties );
                        if ( companion.registerOnBehalf ) {
                            if ( $scope.guestInformation.companionParams.personal.dob ) {
                                _.set( companion, 'birthdayDate', _.get( companion, 'formattedBirthday', [] ).join( '-' ) );
                            }
                            var ffProgram = _.get( companion, 'travelPreferences.ffProgram' );
                            var ffNumber = _.get( companion, 'travelPreferences.ffNumber' );

                            if ( ffProgram && ffNumber ) {
                                var currentFF = _.get( $scope, 'travelPreferences.frequentFlyer' ) || {};

                                currentFF[ ffProgram ] = ffNumber;

                                _.set( companion, 'travelPreferences.frequentFlyer', currentFF );
                                delete companion.travelPreferences.ffProgram;
                                delete companion.travelPreferences.ffNumber;
                            }
                            var surveyAnswers = [];
                            _.get( companion, 'survey' ) && _.each(  _.get( companion, 'survey', [] ), function each ( v, k ) {
                                // only generate something for non statements
                                if ( v && !v.isStatement ) {
                                    if ( typeof v === 'string' ) {
                                        surveyAnswers.push( {
                                            'question': k,
                                            'answer': v
                                        } );
                                    } else {
                                        /**
                                         * If the value is not a string, it's for a multi select so make it
                                         * a stringified array.
                                         */
                                        var multipleValues = [];
                                        _.each( v, function each ( avalue, akey ) {
                                            if ( avalue ) {
                                                multipleValues.push( akey );
                                            }
                                        } );

                                        surveyAnswers.push( {
                                            'question': k,
                                            'answer': JSON.stringify( multipleValues )
                                        } );
                                    }
                                }
                            } );
                            _.set( companion, 'surveyAnswers', surveyAnswers );
                        }
                    }
                } );
                if ( !atLeastOneCompanion && !force ) {
                    $bootbox.dialog( {
                        show: false,
                        message: 'You have selected to not register any companions, are you sure you want to continue?',
                        title: 'Are you sure?',
                        buttons: {
                            main: {
                                label: 'Yes, continue.',
                                className: 'btn-primary',
                                callback: function () {
                                    saveCompanionInvites( $event, form, true );
                                    $bootbox.hideAll();
                                }
                            },
                            danger: {
                                label: 'Cancel',
                                className: 'btn-default',
                                callback: function () {
                                    $timeout( function () {
                                        $scope.submitted = false;
                                        _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );
                                    } );
                                    $bootbox.hideAll();
                                }
                            }
                        },
                        onEscape: function () {
                            $timeout( function () {
                                $scope.submitted = false;
                                _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );
                            } );
                            $bootbox.hideAll();
                        }
                    } ).off( 'shown.bs.modal' ).modal( 'show' );
                    return false;
                }

                // make sure none of the companion email addresses match the guest's email address
                if ( _.includes( companionEmails, $scope.invite.guestID.email.primary ) ) {
                    if ( companionEmails.length > 1 ) {
                        notificationService.error( $scope.invite.guestID.email.primary + $messageDictionary.general.inUse );
                    } else {
                        notificationService.error( 'This email address' + $messageDictionary.general.inUse );
                    }
                    _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );
                } else if ( _.uniq( companionEmails ).length !== companionEmails.length ) {
                    notificationService.error( $messageDictionary.general.companionEmailUnique );
                    _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );
                } else {
                    var data = {
                        guestInfo: $scope.companions,
                        rsvp: 'y',
                        rsvpProcess: 'welcome'
                    };

                    // save the results to the db
                    $http.put( _.get( ENV, 'apiEndpoint' ) + '/ribyt/rsvp/' + invite.inviteHash + '/sendinvite', data )
                        .then( function success ( response ) {
                            delete data.guestInfo;

                            var promises = [];
                            if ( response.data.data ) {
                                $scope.companions.forEach( function ( companion ) {
                                    if ( response.data.data[companion.email] && companion.imageData ) {
                                        promises.push( uploadProfileImage( response.data.data[companion.email], companion.imageData ) );
                                    }
                                } );
                            }

                            $q
                                .all( promises )
                                .then(
                                    function () {
                                        $http.put( _.get( ENV, 'apiEndpoint' ) + '/ribyt/rsvp/' + invite.inviteHash, data )
                                            .then( function success ( response ) {
                                                // Save to sessionStorage
                                                _.set( $sessionStorage, 'invitation', _.get( response, 'data.data' ) );

                                                var decryptedInvite = $rootScope.decryptInvite( _.get( response, 'data.data' ) );
                                                _.set( $rootScope, 'rsvp', decryptedInvite.rsvp );

                                                // there are no errors, so go ahead and update the invite to go to the correct spot
                                                $rootScope.redirectProperly( decryptedInvite, { reload: true } );
                                            } );
                                } );
                        }, function error ( resp ) {
                            var errors = _.get( resp, 'data.error_description', [] ).split( ';' );
                            _.each( errors, function errHandler ( err ) {
                                notificationService.error( err );
                            } );
                            _.set( $scope, 'status', $messageDictionary.buttons.saveAndCont );
                        } );
                }
            }
        }

        function toggleRegisterOnBehalf ( companions, index ) {
            if ( companions[index].registerOnBehalfRadio === 'true' ) {
                companions[index].registerOnBehalf = true;
                companions.forEach( function ( companion, i ) {
                    companion.registerOnBehalfExpanded = i === index;
                } );
                $scope.cropOptions[index] = {
                    maximize: true,
                    aspectRatio: 1,
                    crop: function ( dataNew ) {
                        $scope.companions[index].imageData = dataNew;
                    }
                };
            } else {
                companions[index].registerOnBehalf = false;
                companions[index].registerOnBehalfExpanded = false;
            }
        }

        function toggleEnableCompanion ( companions, index ) {
            if ( companions[index].enabled ) {
                companions[index].registerOnBehalfRadio = 'false';
            }

            if ( companions[index].registerOnBehalf ) {
                companions[index].registerOnBehalf = false;
                companions[index].registerOnBehalfExpanded = false;
            }
        }

        function expandCollapseRegisterOnBehalfSection ( companions, index ) {
            companions[index].registerOnBehalfExpanded = !companions[index].registerOnBehalfExpanded;
            if ( companions[index].registerOnBehalfExpanded ) {
                companions.forEach( function ( companion, i ) {
                    if ( i !== index ) {
                        companion.registerOnBehalfExpanded = false;
                    }
                } );
            }
        }

        var imageFile;
        $scope.dataUrl = {};
        $scope.cropOnFile = cropOnFile;
        $scope.cropClear = cropClear;
        $scope.cropPreview = cropPreview;
        $scope.cropShowEvent = 'show';
        $scope.cropHideEvent = 'hide';
        $scope.cropOptions = [];

        /**
         * Method is called every time file input's value changes.
         * Because of Angular has not ng-change for file inputs a hack is needed -
         * call `angular.element(this).scope().onFile(this.files[0])`
         * when input's event is fired.
         */
        function cropOnFile ( blob, index ) {
            if ( blob ) {
                Cropper.encode( ( imageFile = blob ), index ).then( function ( dataUrl ) {
                    $scope.dataUrl[index] = dataUrl;
                    $timeout( showCropper ); // wait for $digest to set image's src
                } );
            }
        }
        /**
         * When there is a cropped image to show encode it to base64 string and
         * use as a source for an image element.
         */
        function cropPreview ( index ) {
            if ( !imageFile || !$scope.companions[index].imageData ) {
                return;
            }

            // set a delay because guestInfo.imageData in the front end will crap out if it's not ready yet
            $scope.profileDelay = true;
            Cropper.crop( imageFile, $scope.companions[index].imageData ).then( Cropper.encode ).then( function cropperImageFunction ( imageData ) {
                $scope.profileDelay = false;
                $scope.companions[index].imageData = imageData;
                $scope.dataUrl[index] = null;
                _.set( $scope, 'showProfileImageIsRequiredError', false );
                hideCropper();
                // hide the modal
                $( '#cropperModal' + index ).modal( 'hide' );
            } );
        }

        /**
         * Use cropper function proxy to call methods of the plugin.
         * See https://github.com/fengyuanchen/cropper#methods
         */
        function cropClear ( index ) {
            // Clone the file elm to clear it.
            var imageElm = $( '#pictureFile' );
            imageElm.replaceWith( imageElm = imageElm.clone( true ) );

            $scope.companions[index].imageData = null;
            $scope.dataUrl[index] = null;
            hideCropper();
        }

        function showCropper () {
            $scope.$broadcast( $scope.cropShowEvent );
        }

        function hideCropper () {
            $scope.$broadcast( $scope.cropHideEvent );
        }

        function uploadProfileImage ( inviteHash, imageData ) {
            imageData = dataURItoBlob( imageData );
            var deferred = $q.defer();

            /**
             *  At this point, localImage is the cropped Blob object while imageFile is the original
             *  File object.
             */
            if ( _.get( imageData, 'size' ) ) {
                var form = new FormData();
                form.append( 'file', imageData, _.get( imageFile, 'name', 'unknown' ) );

                var settings = {
                    async: true,
                    crossDomain: true,
                    url: ENV.apiEndpoint + '/ribyt/rsvp/' + inviteHash + '/uploadImage',
                    method: 'POST',
                    headers: {},
                    processData: false,
                    contentType: false,
                    mimeType: 'multipart/form-data',
                    data: form
                };

                $
                    .ajax( settings )
                    .done( function () {
                        deferred.resolve();
                    } ).fail( function () {
                        deferred.resolve();
                    } );
            } else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        function dataURItoBlob ( dataURI ) {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            if ( !dataURI || dataURI.match( /^http/ ) ) {
                return false;
            }

            var byteString = atob( dataURI.split( ',' )[ 1 ] );

            // separate out the mime component
            var mimeString = dataURI.split( ',' )[ 0 ].split( ':' )[ 1 ].split( ';' )[ 0 ];

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer( byteString.length );
            var ia = new Uint8Array( ab );
            for ( var i = 0; i < byteString.length; i++ ) {
                ia[ i ] = byteString.charCodeAt( i );
            }

            return new Blob( [ ab ], {
                type: mimeString
            } );
        }
    } ] );
